import { getErrorMessage, getErrorStatus } from '#app/utils/misc.js'
import { useRouteError } from '@remix-run/react'
import { captureRemixErrorBoundaryError } from '@sentry/remix'
import { getReasonPhrase } from 'http-status-codes'
import type { HTMLProps } from 'react'

export function CommonErrorBoundary(props: HTMLProps<HTMLDivElement>) {
	const error = useRouteError()
	captureRemixErrorBoundaryError(error)

	const status = getErrorStatus(error)
	const errorMessage =
		typeof error === 'object' && error && 'data' in error ? getErrorMessage(error.data) : getReasonPhrase(status)

	return (
		<div {...props} className="m-auto flex flex-col items-center pb-[calc(var(--navbar-h)+(--spacing(6)))] text-center">
			<h1 className="text-6xl font-bold text-zinc-950 dark:text-white">{status}</h1>

			{errorMessage ? <p className="pt-3.5 text-base/6 sm:text-sm/6">{errorMessage}</p> : null}

			{/* <div className="pt-8">
				<Button href="/">Go home</Button>
			</div> */}
		</div>
	)
}
